<template>
	<div class="chartInstance" :class="className"></div>
</template>

<script>
import echarts from 'echarts'
export default {
	props: {
		newClasses: {
			type: [String, Number],
			default: null
		},
		classData: Array,
		className: {
			type: String,
			default: 'chartInstance1'
		}
	},
	data() {
		return {
			renderTotalGrade: null,
			classes: '',
			secondClassData: [],
			thirdClassData: []
			// classData: []
		}
	},
	watch: {
		classData: {
			handler() {
				this.drawTotalGrade()
			}
		}
	},
	created() {
		if (this.newClasses == '2班') {
			this.classData = [
				{ value: 6, name: '一档上线率' },
				{ value: 13, name: '二档上线率' },
				{ value: 11, name: '三档上线率' },
				{ value: 22, name: '其他' }
			]
		}
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			this.getData()
		},
		getData() {
			this.$nextTick(() => {
				this.drawTotalGrade()
			})
		},
		drawTotalGrade() {
			this.renderTotalGrade = echarts.init(document.querySelector(`.${this.className}`))
			const colors = ['rgb(0,153,255)', 'rgb(51,204,51)', 'rgb(51,204,204)', 'rgb(255,153,0)']
			this.renderTotalGrade.clear()
			this.renderTotalGrade.setOption({
				tooltip: {
					trigger: 'item',
					formatter: function(data) {
						return `${data.name}: ${data.value}%`
					}
				},
				color: colors,
				legend: {
					selectedMode: false,
					left: -5,
					data: this.classData.map(item => item.name)
				},
				series: [
					{
						type: 'pie',
						right: 70,
						bottom: 20,
						radius: ['45%', '70%'],
						center: ['50%', '60%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: this.classData
					}
				]
			})
		}
	}
}
</script>

<style></style>
